module.exports = __webpack_public_path__ + "img/p4-desc.22d3c073.jpg";